// React
import { useState } from "react";

// UI
import { Autocomplete, Typography, Box, Tooltip } from "@mui/material";
import ColoredTextField from "./ColoredTextField";
import CircularProgress from "@mui/material/CircularProgress";

const AutoCompleteUsers = (props) => {
  // Required
  const {
    row,
    onChange,
    value,
    handleUserInputChange,
    options,
    isLoading,
    name,
  } = props;
  // Optional
  const { label, error, helperText, onClose, errorMessage="" } = props;

  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event, newValue, reason) => {
    setInputValue(newValue);

    handleUserInputChange(newValue, name, reason, row);
  };

  return (
    <>
	<Tooltip title={value ? `${value.username} <${value.userid}>`?.trim() : ""}>
      <Autocomplete
        fullWidth
        onClose={onClose}
        autoHighlight
        id="AutoComplete User"
        options={!isLoading ? options : []}
        loading={isLoading}
        onChange={onChange}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        filterOptions={(options) => options}
        loadingText={
          <Box display={"flex"} sx={{ mx: "auto" }}>
            <CircularProgress color="inherit" size={80} />
          </Box>
        }
        value={value === "" ? null : value}
        getOptionLabel={(option) => {
          return `${option.username} <${option.userid}>`?.trim() || "";
        }}
        isOptionEqualToValue={(option, value) => {
          return JSON.stringify(option) === JSON.stringify(value);
        }}
        renderOption={(props, option) => {
            const { key, ...restProps } = props;
            return (
                <li key={key + option?.username + option?.userid} {...restProps}>
                    {`${option.username} <${option.userid}>`}
                </li>
            );
        }}
        noOptionsText={
          inputValue?.trim().length > 2
            ? "No Result"
            : "Enter at least 3 characters to search"
        }
        renderInput={(params) => (
          <ColoredTextField
            error={error ? true : false}
            focused
						required={props.required || false}
            {...params}
            label={label}
          />
        )}
      />
      </Tooltip>
      <Typography variant="caption" color={error && "secondary"}>
        {errorMessage || helperText}
      </Typography>
    </>
  );
};

export default AutoCompleteUsers;
